module.exports = __webpack_public_path__ + "static/media/Spreadsheet.8be49052.svg";